import { gql } from '@apollo/client';

export const GENERATE_MAINTENANCE = gql`
  mutation BI_REPORT_SERVICE_generateMaintenance($type: FileType!, $recipients: [String]!) {
    generateMaintenance(type: $type, recipients: $recipients)
  }
`;
